import { useEffect, useState } from 'react';

import useTimeout from '@/hooks/useTimeout';
import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';
import authConstants from '@/v2/domains/Auth/constants/constants';
import { usePrivatePageStore } from '@/v2/domains/Auth/stores/usePrivatePageStore';
import useIsFlowPage from '@/v2/domains/Auth/hooks/useIsFlowPage.hook';
import useGetUnansweredSurveysQuery from '@/v2/domains/Surveys/queries/useGetUnansweredSurveysQuery.hook';
import {
  floatingSurveyPostLoginDelayMs,
  floatingSurveyQueryKey,
  surveyTag,
} from '@/v2/domains/Surveys/constants/constants';

const floatingTags = [surveyTag.EVERYWHERE, surveyTag.FLOATING];

export default function useFloatingSurveyVisibility() {
  const [visible, setVisible] = useState(false);
  const [isReady, setIsReady] = useState(false);

  const { userType } = useCurrentUser();
  const isTeacher = userType == authConstants.userType.teacher;

  const { isPrivatePage } = usePrivatePageStore();
  const isFlowPage = useIsFlowPage();

  useTimeout(
    () => {
      setIsReady(true);
    },
    isTeacher ? floatingSurveyPostLoginDelayMs : null
  );

  const queryEnabled = isTeacher && isPrivatePage && isReady && !isFlowPage;

  const { data } = useGetUnansweredSurveysQuery({
    queryKey: floatingSurveyQueryKey,
    tags: floatingTags,
    enabled: queryEnabled,
  });

  const survey = data?.unansweredSurveys?.[0];

  useEffect(() => {
    setVisible(queryEnabled && !!survey);
  }, [queryEnabled, survey]);

  return { visible, survey, hide: () => setVisible(false) };
}
